import { render, staticRenderFns } from "./AdminActividades.vue?vue&type=template&id=5675fe19&"
import script from "./AdminActividades.vue?vue&type=script&lang=js&"
export * from "./AdminActividades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports